<template>
    <trax-ui-modal-plain-header :id="id+'-modal'" :bus="bus">

        <div :id="id" v-if="procedure">

            <p class="pl-2">
                <strong>{{ lang.polaris.account.group }}: </strong> {{ procedure.notifications[0].data.context.cohort.name }}
                <br>
                <span v-if="procedure.user_id">
                    <strong>{{ lang.polaris.dashboard.learner }}: </strong> {{ procedure.notifications[0].data.context.user.name }}
                </span>
            </p>

            <trax-ui-simple-table :id="id" header="0" :cols="cols" :rows="rows">
            </trax-ui-simple-table>
             
            <div class="text-center mt-0 mb-3">

                <!-- Delete button -->
                <button class="btn btn-round btn-danger" @click="deleteNotifs">
                    {{ lang.polaris.notification.delete_all_messages }}
                </button>

            </div>

        </div>

    </trax-ui-modal-plain-header>
</template>

<script>
    export default {
    
        props: {
            id: { default: 'trax-notification-procedure' },
        },
    
        data: function() {
            return {
                lang: lang,
                app_url: app_url,
                endpoint: app_url+"polaris/api/front/procedure-notifications",
                cols: [{}],
                rows: [],
                procedure: null,
                bus: this.$bus
            }
        },

        created: function() {
            this.bus.$on(this.id+'-modal-open', this.opened);
        },

        methods: {
        
            opened(event) {
                this.procedure = event.data;
                this.initRows(this.procedure.notifications);
                if (this.procedure.unread_notifications == 0) {
                    return;
                }
                
                // Record status
                var that = this;
                var data = { id: this.procedure.id, read: true, notification_ids: this.procedure.notifications.map(n => n.id) };
                axios.put(this.endpoint+'/'+this.procedure.id, data)
                    .then(function (response) {
                        that.bus.$emit(that.id+'-notification-read', that.procedure.id);
                    })
                    .catch(function (error) {
                    });
            },

            initRows(notifications) {
                this.rows = [];
                for (var index in notifications) {
                    var notification = notifications[index];
                    var res = '';
                    if (!notification.pivot.read) {
                        res += '<span class="badge badge-danger float-right ml-1">'+this.lang.polaris.notification.new+'</span>';
                    }
                    res += '<span class="font-weight-bold">'+this.trans(notification.data.content.title)+'<span>';
                    res += '<br><small class="font-weight-light">'+moment(notification.created_at).format('DD MMM YYYY')+'</small>';
                    if (notification.data.content.action) {
                        var url = this.url(notification.data.content.action.url)
                        res = '<div class="notification-link" style="cursor:pointer" onclick="window.location=\'' + url + '\'">'+res+'</div>';
                    }
                    this.rows.push([res]);
                }
            },

            deleteNotifs: function(event) {
                var that = this;
                var data = { id: this.procedure.id, notification_ids: this.procedure.notifications.map(n => n.id) };
                axios.delete(this.endpoint+'/'+that.procedure.id, {params: data})
                    .then(function (response) {
                        that.bus.$emit(that.id+'-modal-close');
                        that.bus.$emit(that.id+'-notification-deleted', that.procedure.id);
                    })
                    .catch(function (error) {
                    });
            },

            trans(key) {
                return this.lang.polaris.notification[key.split('.').pop()]
            },

            url(url) {
                // Replace the TRAX path.
                var absoluteUrl = url.includes('/enac/ui')
                    ? this.app_url + (new URL(url)).pathname.replace('/enac/ui', 'polaris/ui')
                    : url

                // Be sure to target the current server domain. Usefull when the prod BD is moved on the test server.
                var parts = absoluteUrl.split('polaris/ui')
                absoluteUrl = this.app_url + 'polaris/ui' + parts[1]

                return absoluteUrl
            }
        }
    }
</script>
